import config from '../../config/config';
import DefaultApiLimit from '../../config/defaultLimit';

import deleteRequest from './base/delete';
import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch devices API
   * @param query
   */
  fetchDevices: (id: string) => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/vlbc/charging-points/${id}`);
  },
  /**
   * Fetch charging stations API
   * @param query
   */
  fetchChargingStations: () => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/vlbc/charging-stations-list`);
  },
  /**
   * Create the load balancer
   * @param data
   * @returns
   */
  createVlbc: (data: any): Promise<any> => {
    const parameters = { ...data };
    return postRequest(`${config.commonApiUrl}api/facility/v1/vlbc`, {
      ...parameters,
    });
  },
  /**
   * Fetch vlbcs API
   * @param query
   */
  fetchVlbcs: (query: QueryParameters = {}) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(`${config.commonApiUrl}api/facility/v1/vlbc`, {
      ...parameters,
    });
  },
  /**
   * Fetch vlbc API
   * @param id
   */
  fetchVlbc: (vlbcId: string) => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/vlbc/${vlbcId}`);
  },
  /**
   * Update the load balancer
   * @param vlbcId
   * @param data
   * @returns
   */
  updateVlbc: (vlbcId: string, data: any): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(`${config.commonApiUrl}api/facility/v1/vlbc/${vlbcId}`, {
      ...parameters,
    });
  },
  /**
   * Update the load balancer status
   * @param vlbcId
   * @param data
   * @returns
   */
  updateVlbcStatus: (vlbcId: string, data: any): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(`${config.commonApiUrl}api/facility/v1/vlbc/update-status/${vlbcId}`, {
      ...parameters,
    });
  },
  /**
   * Assign chargers count
   * @returns
   */
  assignChargersCount: (): Promise<any> => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/vlbc/charger-assign-counts`);
  },
  /**
   * Delete vlbc
   * @param vlbcId
   * @returns
   */
  deleteVlbc: (vlbcId: string): Promise<any> => {
    return deleteRequest(`${config.commonApiUrl}api/facility/v1/vlbc/${vlbcId}`);
  },
  /**
   * fetch vlbc logs
   * @param vlbcId
   * @returns
   */
  fetchVlbcLogs: (vlbcId: string, query: QueryParameters = {}) => {
    const parameters = { ...query };

    return getRequest(`${config.commonApiUrl}api/facility/v1/vlbc/vlbc-logs/${vlbcId}`, {
      ...parameters,
    });
  },
  /**
   * fetch vlbc logs
   * @param vlbcId
   * @returns
   */
  fetchVlbcOverview: (vlbcId: string) => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/vlbc/vlbc-overview/${vlbcId}`);
  }, 
};
